import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography, Card  } from "@material-tailwind/react";

import Loader from "../../../../components/Loader";
import { RootState } from "../../../../redux";
import { Vehicle, updateVehicleRequest } from "../../../../redux/vehicles/actions";
import { Field, getField } from "../../../../components/DetailsFormField";
import renderField from "../../../../components/DetailsFormField";

const TRANSPORT_FIELDS: Field[] = [
    { n: "Transport Company", f: "delivery_company", editable: true, type: "text" },
    { n: "Load ID", f: "delivery_order", editable: true, type: "text" },
    { n: "Delivery Cost", f: "delivery_cost", editable: true, type: "money" },
    { n: "From Location", f: "delivery_from", editable: true, type: "text" },
    { n: "To Location", f: "delivery_to", editable: true, type: "text" },
    { n: "Est. Delivery Date", f: "delivery_est_date", editable: true, type: "date", hide: 'delivery_date' },
    { n: "Delivery Date", f: "delivery_date", editable: false, type: "text", show: "delivery_date" },
    { n: "Person Recieved", f: "signed_by.fullname", editable: false, type: "text" },
    { n: "Person Signature", f: "signature", editable: false, type: "image" },
];


export function DashboardVehicleInventoryTabTransport() {
    const dispatch = useDispatch();
    const { vehicle } = useSelector((state: RootState) => state.vehicles);
    const [isEdit, setIsEdit] = useState(false);
    const [newVehicle, setNewVehicle] = useState<Vehicle>({} as Vehicle);

    useEffect(() => {
        if (vehicle) {
            setNewVehicle(vehicle);
        }
    }, [vehicle]);

    const saveEdit = () => {
        setIsEdit(false);
        const update_fields = Object.keys(newVehicle).filter(
            (key) => newVehicle[key as keyof Vehicle] !== vehicle?.[key as keyof Vehicle]
        );

        if (update_fields.length === 0) return;

        dispatch(
            updateVehicleRequest({
                vehicle: newVehicle,
                update_fields: [
                    'id',
                    ...update_fields,
                ]
            })
        );
    };

    return !vehicle ? (
        <Loader />
    ) : (
        <React.Fragment>
            <Card className="p-2 md:p-5 gap-y-5 flex flex-col">
                <Card.Header>
                    <div className="flex justify-between">
                        <div className="">
                            <Typography className="block font-bold text-primary">
                                Shipment Details
                            </Typography>
                            <Typography type="small" className="block text-foreground">
                                Key shipment info: ID, price, route, date, and recipient.
                            </Typography>
                        </div>
                        {isEdit ? (
                            <div className="flex gap-2">
                                <Button
                                    variant="outline"
                                    color="error"
                                    className="h-8 flex items-center gap-2"
                                    onClick={() => setIsEdit(false)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="outline"
                                    color="success"
                                    className="h-8 flex items-center gap-2"
                                    onClick={saveEdit}
                                >
                                    Save
                                </Button>
                            </div>
                        ) : (
                            <Button
                                variant="outline"
                                color="secondary"
                                className="h-8 flex items-center gap-2"
                                onClick={() => {
                                    setIsEdit(true);
                                    setNewVehicle(vehicle);
                                }}
                            >
                                Edit
                            </Button>
                        )}
                    </div>
                </Card.Header>
                <Card.Body className="!p-0 m-2">
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-y-5 justify-stretch">
                        {TRANSPORT_FIELDS.filter((field) => {
                            return (!field?.hide || !getField(field.hide, newVehicle)) && (!field?.show || getField(field.show, newVehicle))
                        }).map((field, idx) => (
                            <div key={idx} className="">
                                {renderField(field, isEdit, newVehicle, setNewVehicle)}
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>
        </React.Fragment>
    );
}
